import ResetPasswordCard from './resetPasswordCard'

export default ResetPasswordCard